module.exports = __webpack_public_path__ + "media/promo/courses/images/access2-4e661da2983165b93d02b88753237d19.jpg";